import Footer from "../../../components/Footer/Footer";
import NavBar from "../../../components/NavBar/NavBar";
import Title from "../../../components/Title/Title";
import CustomButton from "../../../components/Custom-Button/CustomButton";
export default function TenthCommandment() {

    return (
        <div>
            <NavBar/>
            <Title text={"Não Cobiçar as Coisas Alheias"}/>

            <p className="info-text">
                Este mandamento complementa o 9º. Ele ataca a raiz do pecado da injustiça: a cobiça e a inveja[4]. <br/> 
                O CIC explica que desejar imensamente riquezas alheias (“concupiscência dos olhos”) leva ao roubo, à fraude e à injustiça[4]. <br/>
                Portanto, condena o amor excessivo ao dinheiro e ao poder (“avarentos nunca se fartam de dinheiro” – Sb 5,9 citado)[102]. <br/>
                Não é pecado desejar coisas alheias por meios legítimos, mas é pecado desejar injustamente o que não é nosso[103][104]. <br/>
                O mandamento exige banir a inveja – tristeza perante o bem do outro e querer tirar-lho[105]. <br/>
                A inveja é vista como vício capital que gera ódio e calúnia[106]. <br/>
                Lutar contra o orgulho e a cobiça, portanto, é inseparável da vida espiritual cristã.
            </p> 

            <Title text={"Aplicação Cotidiana"}/>
            <p className="info-text">
            No dia a dia, envolve cultivar a generosidade e a gratidão. 
            Viver este mandamento significa alegrar-se com o sucesso alheio e controlar as ambições: por exemplo, não desejar secretamente a promoção do colega, nem ficar descontente com a prosperidade do vizinho. 
            Ser moderado no consumo, partilhar recursos (tempo, dinheiro) com os necessitados e praticar a esmola fraterna ajudam a evitar a cobiça. 
            Financiar-se honestamente para comprar algo que se deseja (via trabalho ou poupança) é permitido; mas comprar por explorar crise alheia (inflacionar preços na falta de estoques) é pecado[76][103]. 
            Em família, educar filhos a não querer tudo que veem na TV ou na casa dos amigos, mas a valorizar o que têm. 
            Socialmente, combater o consumismo, a manipulação de desejos pelas propagandas, e as práticas econômicas predatórias (como desejarem doenças para lucrar[104]) são exigências deste mandamento. 
            Em suma: contentamento com os próprios bens e viver a solidariedade, evitando qualquer forma de cobiça.
            </p> 

            <Title text={"Aspectos Teológicos"}/>
            <p className="info-text">
            A cobiça fere o primeiro mandamento (idolatria do dinheiro) e o segundo (vaidade), pois é sintoma do coração inclinado a outros “deuses”[4]. 
            O CIC mostra que a cobiça dos bens alheios é obra de Satanás (inveja demoníaca)[105]. 
            O mandamento aponta ao pobre em espírito (Mt 5,3): aquele que não se apega aos bens terrenos e busca antes o Reino de Deus[107]. 
            Jesus pede renunciar a todos os bens por amor a Ele, exemplificando que “onde está o teu tesouro, aí estará também o teu coração” (Mt 6,21)[108]. 
            Lutando contra inveja e avareza, o cristão alcança a paz interior. 
            A inveja destrói “o corpo de Cristo”, lembra o CIC[105]. 
            Portanto, vencer a inveja é exercer humildade e caridade, louvando a Deus pela felicidade do outro[109]. 
            Teologicamente, esse mandamento inscreve-se nas bem-aventuranças: o reino de Deus é dos pobres de espírito, que reconhecem que só Deus supre todas as necessidades verdadeiras (fome, êxito espiritual, fraternidade)[107].                
            </p> 
 
            <CustomButton route={"/Mandamentos"} text={"Voltar"}/>
            <Footer/>
        </div>
    )
}